import { PHASES } from "@/lib/constants";

export default function PipelinePill({ phase, size = "md" }) {
  const p = PHASES.find((x) => x.n === phase) || PHASES[0];
  const h = size === "sm" ? "h-2" : "h-3.5";
  return (
    <div className="min-w-0">
      <div className={`${h} w-full rounded-full bg-black/10 overflow-hidden`} data-testid="pipeline-pill">
        <div
          className={`${h} rounded-full transition-all duration-500`}
          style={{ width: `${p.pct}%`, backgroundColor: p.color }}
        />
      </div>
      {size !== "sm" && (
        <p className="font-mono2e text-[0.62rem] mt-1.5" style={{ color: p.color }}>
          {p.label.toUpperCase()} · {p.pct}%
        </p>
      )}
    </div>
  );
}
